
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import axios from "axios";
import { useState, useEffect } from "react";
import { AccessToken } from "../../config/AccessToken";

export const RegularTag = () => {

  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [error, setError] = useState('');
  const [instance, accessTokenRequest] = AccessToken();
  let languageId = localStorage.getItem('languageId');

  const [devicesInfo, setDevicesInfo] = useState<any>(null);

  const getDeviceList = async (flag: boolean) => {

    const commonOperations = (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      axios.get(`${SERVER_URL}/device/active`, {
        headers,
        params: {
          enabled: flag
        }
      })
        .then((res) => {
          const data: any = res?.data
          let infoDevices: any = data?.data
          setDevicesInfo(infoDevices);
        }).catch((data) => {
          setError(data?.message);
        });
    }

    if (sessionStorage.getItem('accessToken') != null) {
      let accessToken = sessionStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.setActiveAccount(accessTokenRequest.account);
      await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
        // Acquire token silent success
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
        .catch((error: any) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
          console.log(error);
        });
    }
  }

  useEffect(() => {
    getDeviceList(true)
  }, [])

  const convertDDMMYYYYHHMMSStoISO = (dateString:any) =>{
    // 1. Split the string into date and time parts
    const [datePart, timePart] = dateString.split(' ');
  
    // 2. Split the date part into day, month, and year
    const [day, month, year] = datePart.split('/');
  
    // 3. Split the time part into hours, minutes, and seconds
    const [hours, minutes, seconds] = timePart.split(':');
  
    // 4. Create a new Date object.  Important: Months are 0-indexed!
    const date = new Date(year, month - 1, day, hours, minutes, seconds);
  
    // 5. Convert to ISO string
    const isoString = date.toISOString();
  
    return isoString;
  }

  const regularTag:any = localStorage.getItem('regularTag')
  let currRegularTag: any = 0

  const now = new Date()
  const actualDate:any = new Date(now.getTime() - regularTag * 60 * 60 * 1000); // Subtract hours

  const dateFormatted:any = actualDate.toISOString()

  devicesInfo?.forEach((device: any) => {
    if(device.dateTime != null){

      const converted:any = convertDDMMYYYYHHMMSStoISO(device.dateTime)

      if( converted > dateFormatted){
        currRegularTag++
      }
    }
  });

return (
  <div style={{ containerType: 'inline-size' }}>
    <div className="dashboard-card-content" >
      <p className="dashboard-card-content-number regular-tag first-value">{currRegularTag}</p>
      {devicesInfo?.length > 0 &&
        <>
          <p className="dashboard-card-content-number regular-tag slash">/</p>
          <p className="dashboard-card-content-number regular-tag blue">{devicesInfo?.length}</p>
        </>
      }
    </div>
  </div>
);
};